import { useCallback, useContext } from "react";
import analytics from "analytics";
import { CheckoutContext } from "contexts/CheckoutProvider";
import useExcludeFromAnnual from "utils/hooks/useExcludeFromAnnual";
import { SUBSCRIPTION_PLAN_SLUGS } from "components/PlanSelection/planSelectionTypes";

export function useDefaultFunnelPlan() {
  const { updateSelectedPlan } = useContext(CheckoutContext);

  const { excludeFromAnnual } = useExcludeFromAnnual();

  const setPlan = useCallback(async () => {
    const { TBYB_MONTHLY_2025, TBYB_ANNUAL_INC_20_CREDITS_60 } =
      SUBSCRIPTION_PLAN_SLUGS;

    const plan = excludeFromAnnual
      ? TBYB_MONTHLY_2025
      : TBYB_ANNUAL_INC_20_CREDITS_60;

    await updateSelectedPlan?.({ plan });

    analytics?.setAmplitudeUserProperties({
      subscription_type: plan,
    });

    return plan;
  }, [excludeFromAnnual, updateSelectedPlan]);

  return { setPlan };
}
